import React from "react";
import { FaPhoneAlt } from "react-icons/fa"; // Phone call icon
import "./calling.css"; 

const Calling = () => {
     const phoneNumber = "919911753333";
 return (
     
    <>
    <a
      href={`tel:${phoneNumber}`}
      className="call-floating-button"
      title="Call Us"
    >
      <div className="call-icon-ring">
        <FaPhoneAlt className="call-icon" size={20} />
      </div>
    </a>
</>
  );
};

export default Calling;
